import React from "react";
import _ from "lodash";
import { useIntl } from "react-intl";
import { EuiFlexItem } from "@elastic/eui";
import { useSelector } from "react-redux";
import TripDetailsSection from "../TripDetailsSection";
import { getUserRoles } from "../../../../auth/slice";
import { userRoles } from "../../../../../constants/userRoles";

export default function TripSourceDetails({ label, options, unit, onChange, isEditable }) {
    const intl = useIntl();
    const getCurrentUserRoles = useSelector(getUserRoles());
    const shipmentUnitDetailsIsEditable =
        getCurrentUserRoles.some((role) => role === userRoles.ACCOUNT_MANAGER) || isEditable;
    return (
        <EuiFlexItem>
            <TripDetailsSection
                label={label}
                selectedValue={intl.formatMessage({
                    id: `shipmentUnit.${_.kebabCase(unit)}`,
                })}
                options={options}
                onSave={onChange}
                isEditable={shipmentUnitDetailsIsEditable}
            />
        </EuiFlexItem>
    );
}
